import React from 'react';
import { PopupMessageContent } from '../Constant/Constant';
import { connect } from 'react-redux';
import { setShowPopUp, setCurrentStep } from '../OwnershipTransferSellerSlice';
import EpiContext from '@episerver/spa-core/Spa';
import Config from '../../../../Config';
import MessagePopup from './MessagePopup';

const OwnershipTransferSellerPopupWrapper = (props) => {


  const popupActions = {
    closePopup: () => props.setShowPopUp(false),
    createWorkOrder: () => { props.createWorkOrder(), props.setShowPopUp(false) },
    doNextStep: () => { props.setShowPopUp(false), props.setCurrentStep(props.data.currentPopupData.nextStep) },
  };

  return <div>
    <MessagePopup popupData={props.data.currentPopupData}
      buttonClick={popupActions[props.data.currentPopupData.buttonClick]}
      secondButtonClick={popupActions[props.data.currentPopupData.secondButtonClick]} />
  </div>;
};
const mapStateToProps = (state) => ({
  data: state.OwnershipTransferPrivateSeller,
});

const mapDispatchToProps = { setShowPopUp, setCurrentStep };

export default connect(mapStateToProps, mapDispatchToProps)(OwnershipTransferSellerPopupWrapper);
